// --- Adding observer for .nav-search-container ---
const searchObserver = new MutationObserver((mutationsList) => {
  mutationsList.forEach((mutation) => {
    // console.log('Search mutation detected:', mutation);

    // Check if the mutation is related to child list changes
    if (mutation.type === "childList") {
      console.log(
        "Child elements of .nav-search-container were added or removed"
      );
      // After child elements are added, observe newly added <details> elements for "open" attribute
      const addedNodes = mutation.addedNodes;
      addedNodes.forEach((node) => {
        if (node.tagName === "DETAILS") {
          observeDetails(node); // Add observer for the new <details> element
        }
      });
      // reinitializeCarousels();
    }

    // Check if the mutation is related to attribute changes (like the "open" attribute of <details>)
    if (mutation.type === "attributes" && mutation.attributeName === "open") {
      const detailsElement = mutation.target;
      if (detailsElement.hasAttribute("open")) {
        console.log("<details> is now open");
        // document.body.removeAttribute("style");
        
      } else {
        console.log("<details> is now closed");
        // Trigger any actions when <details> is closed
      }
    }
  });
});

// Function to observe individual <details> element for 'open' attribute changes
function observeDetails(detailsElement) {
  const detailsObserver = new MutationObserver((mutationsList) => {
    mutationsList.forEach((mutation) => {
      if (mutation.type === "attributes" && mutation.attributeName === "open") {
        if (detailsElement.hasAttribute("open")) {
          document.querySelector(".nav-search-container").style.position =
            "absolute";
          document
            .querySelector(".nav-search-container")
            .classList.add("detail-open");
          reinitializeCarousels();
          console.log("<details> is now open");
        } else {
          document.querySelector(".nav-search-container").style.position =
            "relative";
          document
            .querySelector(".nav-search-container")
            .classList.remove("detail-open");

          console.log("<details> is now closed");
        }
      }
    });
  });

  detailsObserver.observe(detailsElement, {
    attributes: true, // Observe changes to the 'open' attribute
    attributeFilter: ["open"], // Only track the 'open' attribute
  });
}

// Select the .nav-search-container element
const searchContainer = document.querySelector(".nav-search-container");
if (searchContainer) {
  // Observe for child list changes (like when new <details> elements are added)
  searchObserver.observe(searchContainer, {
    childList: true, // Observe for changes in the children of .nav-search-container
    subtree: true, // Observe also the descendants of the .nav-search-container
  });

  // Also, observe existing <details> elements
  const detailsElements = searchContainer.querySelectorAll(
    ".header__search details"
  );
  detailsElements.forEach(observeDetails); // Initialize observers for existing <details> elements
}

// IntersectionObserver for visibility (if needed)
const searchVisibilityObserver = new IntersectionObserver(
  (entries, observer) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        console.log(".nav-search-container is now visible in the viewport");
      }
    });
  },
  {
    root: null,
    rootMargin: "0px",
    threshold: 0.1,
  }
);

if (searchContainer) {
  searchVisibilityObserver.observe(searchContainer);
}

document.addEventListener("click", function (event) {
  // Check if the click was on the close button or the svg inside it
  if (event.target.closest(".search-modal__close-button")) {
    // Find the parent details element (if any)
    const detailsElement = document.querySelector("details[open]");
    if (detailsElement) {
      // Remove the open attribute to collapse the details
      detailsElement.removeAttribute("open");
    }
  }
});
